import { get, post } from '../api.service';

export const setNewPassword = async (token: string, password: string) => {
    const language = localStorage.getItem("i18nextLng");
    return await post(`/signup/update-password`, {
        token,
        newPassword: password,
        confirmPassword: password,
        language
    });
};
